import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { mnmHttpInterceptorParams, Result } from 'mnm-webapp';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from '@masar/env/environment';
import { KpiAnnualTransitionStatistics } from '@masar/common/models';
import { YearService } from './year.service';

@Injectable()
export class KpiAnnualTransitionPendingCountService implements OnDestroy {
    private pendingCountSubject = new BehaviorSubject<number>(0);
    private unsubscribeAll = new Subject<void>();

    public constructor(
        private readonly httpClient: HttpClient,
        private readonly yearService: YearService
    ) {
        this.yearService.changes$
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe(() => this.refresh());
    }

    public get pendingCount$(): Observable<number> {
        return this.pendingCountSubject.asObservable();
    }

    public get pendingCount(): number {
        return this.pendingCountSubject.value;
    }

    public ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
        this.pendingCountSubject.complete();
    }

    public refresh(targetYear?: number): void {
        const year = targetYear ?? this.yearService.get();

        this.httpClient
            .get<Result<KpiAnnualTransitionStatistics>>(
                `${environment.apiUrl}/kpi-annual-transition/statistics`,
                {
                    params: new HttpParams()
                        .set('targetYear', `${year}`)
                        .append(mnmHttpInterceptorParams.stealth, 'true'),
                }
            )
            .pipe(map(result => result.extra?.pendingApproval ?? 0))
            .subscribe({
                next: count => this.pendingCountSubject.next(count),
                error: () => this.pendingCountSubject.next(0),
            });
    }
}
